/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { federation_category_all } from '../models/federation_category_all';
import type { federation_club_dto } from '../models/federation_club_dto';
import type { federation_club_full } from '../models/federation_club_full';
import type { federation_company_all } from '../models/federation_company_all';
import type { federation_company_dto } from '../models/federation_company_dto';
import type { federation_company_full } from '../models/federation_company_full';
import type { federation_player_full } from '../models/federation_player_full';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FederationService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get all company categories
   * @returns federation_category_all successful
   * @throws ApiError
   */
  public getCategories({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<federation_category_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/federation/categories',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get all clubs
   * @returns federation_club_full successful
   * @throws ApiError
   */
  public getClubs({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<federation_club_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/federation/clubs.json',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get a club
   * @returns federation_club_full successful
   * @throws ApiError
   */
  public getClub({
    locale,
    clubId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Club identifier
     */
    clubId: string;
  }): CancelablePromise<federation_club_full> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/federation/clubs/{club_id}',
      path: {
        locale: locale,
        club_id: clubId,
      },
    });
  }
  /**
   * Get all companies
   * @returns federation_company_all successful
   * @throws ApiError
   */
  public getCompanies({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<federation_company_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/federation/companies',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Create a new company
   * @returns federation_company_full successful
   * @throws ApiError
   */
  public createCompany({
    locale,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    requestBody?: federation_company_dto;
  }): CancelablePromise<federation_company_full> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/federation/companies',
      path: {
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get a company
   * @returns federation_company_full successful
   * @throws ApiError
   */
  public getCompany({
    locale,
    companyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Company identifier
     */
    companyId: string;
  }): CancelablePromise<federation_company_full> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/federation/companies/{company_id}',
      path: {
        locale: locale,
        company_id: companyId,
      },
    });
  }
  /**
   * Update the company
   * @returns federation_company_full successful
   * @throws ApiError
   */
  public updateCompany({
    locale,
    companyId,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Company identifier
     */
    companyId: string;
    requestBody?: federation_company_dto;
  }): CancelablePromise<federation_company_full> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/{locale}/api/v1/federation/companies/{company_id}',
      path: {
        locale: locale,
        company_id: companyId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Delete the company
   * @returns void
   * @throws ApiError
   */
  public deleteCompany({
    locale,
    companyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Company identifier
     */
    companyId: string;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/{locale}/api/v1/federation/companies/{company_id}',
      path: {
        locale: locale,
        company_id: companyId,
      },
    });
  }
  /**
   * Get my clubs
   * @returns federation_club_full successful
   * @throws ApiError
   */
  public getMyClubs({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<federation_club_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/federation/my_clubs',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Create a new club
   * @returns federation_club_full successful
   * @throws ApiError
   */
  public createMyClub({
    locale,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    requestBody?: federation_club_dto;
  }): CancelablePromise<federation_club_full> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/federation/my_clubs',
      path: {
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get a club
   * @returns federation_club_full successful
   * @throws ApiError
   */
  public getMyClub({
    locale,
    clubId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Club identifier
     */
    clubId: string;
  }): CancelablePromise<federation_club_full> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/federation/my_clubs/{club_id}',
      path: {
        locale: locale,
        club_id: clubId,
      },
    });
  }
  /**
   * Update my club
   * @returns federation_club_full successful
   * @throws ApiError
   */
  public updateMyClub({
    locale,
    clubId,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Club identifier
     */
    clubId: string;
    requestBody?: federation_club_dto;
  }): CancelablePromise<federation_club_full> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/{locale}/api/v1/federation/my_clubs/{club_id}',
      path: {
        locale: locale,
        club_id: clubId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Delete my club
   * @returns void
   * @throws ApiError
   */
  public deleteMyClub({
    locale,
    clubId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Club identifier
     */
    clubId: string;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/{locale}/api/v1/federation/my_clubs/{club_id}',
      path: {
        locale: locale,
        club_id: clubId,
      },
    });
  }
  /**
   * Get all players
   * @returns federation_player_full successful
   * @throws ApiError
   */
  public getPlayers({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<federation_player_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/federation/players.json',
      path: {
        locale: locale,
      },
    });
  }
}
